<template>
  <b-autocomplete
    readonly
    v-bind="$attrs"
    :data="options"
    :value="value"
    @typing="onChangeInput"
    @select="onChangeSelect"
    :keep-first="true"
  >
    <template v-slot="{ option }">
      <slot
          name="option"
          :option="option"
      >
        <hr
            v-if="option.bordered"
            style="position: absolute; top: 0; right: 0; left: 0; margin: 0;"
        >
        <div
            style="white-space: normal;"
            :value="option.value"
            :style="!option.available ? 'color: #adadad;' : null"
            v-text="option.label"
        />
      </slot>
    </template>
  </b-autocomplete>
</template>

<script>
import { constants } from '@/services/constants.service'
import get from 'lodash/get'

export default {
  name: 'WsSelectComplexityCode',
  props: {
    competence: {
      type: Object,
      required: false
    },
    dateFilter: {
      type: Date,
      required: false,
      default () {
        return null
      }
    },
    isDependsOfCompetence: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    value: { type: String },
    onChange: {
      type: Function
    }
  },
  data () {
    return {
      complexityLevelList: constants.COMPEXITY_LEVELS
    }
  },
  computed: {
    options () {
      const lValue = this.value ? this.value.toLowerCase() : ''
      if (this.isDependsOfCompetence) {
        const df = this.dateFilter
        const codeDates = this.competence.item ? get(this.competence.item, 'code_dates') || [] : []

        if (df === null || codeDates.length === 0) {
          const levels = this.competence.item ? get(this.competence.item, 'complexity_level') || [] : []
          return levels.map((value, index, arr) => ({
            value,
            label: value,
            available: true,
            bordered: index && value[0] !== arr[index - 1][0]
          })).filter(item => item.value.toLowerCase().indexOf(lValue) >= 0)
        } else {
          const levels = codeDates
          return levels.filter(el => new Date(el.activeFrom) <= df && df <= new Date(el.activeTo)).map((value, index, arr) => ({
            value: value.code,
            label: value.code + (value.educationalQualifications && value.educationalQualifications[0] ? ': ' + value.educationalQualifications[0].title : ''),
            available: true,
            bordered: false
          })).filter(item => item.value.toLowerCase().indexOf(lValue) >= 0)
        }
      } else {
        return this.complexityLevelList.map((value, index, arr) => ({
          value,
          label: value,
          available: true,
          bordered: index && value[0] !== arr[index - 1][0]
        })).filter(item => item.value.toLowerCase().indexOf(lValue) >= 0)
      }
    }
  },
  methods: {
    onChangeSelect (option) {
      const value = option ? option.value : null
      this.onChange(value)
    },
    onChangeInput (val) {
      this.complexityLevelList = constants.COMPEXITY_LEVELS.filter(word => word.includes(val))
      this.onChange(val)
    }
  }
}
</script>
